
import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import GiftList from "./components/GiftList.vue";
import GiftListClubModal from "@/components/GiftListClubModal.vue";

@Component({
	components: {
		GiftList,
		GiftListClubModal,
	},
})
export default class App extends Vue {
	giftList: string[] = [];
	giftListId: string = "";
	giftListPids: string[] = [];
	hasGiftList: boolean = true;
	// isLoggedUser: boolean = false;
	showClubModal = false;
	clubDiscount = "";

	get isLoggedUser() {
		return !!this.$parent.$data.isLoggedUser;
	}

	get giftListComputed() {
		return this.giftList;
	}

	created() {
		// this.isLoggedUser = !!this.$parent.$data.isLoggedUser;
		this.giftListId = this.$parent.$data.giftListId;
		this.giftList = this.getGiftList();

		// NOTE: trigger clear gift list for search
		// TODO: use event epoqUpdateGiftList in search script
		// this.triggerForeignGiftListRemoval(undefined);

		console.log("$bus", this.$bus);

		this.$bus.$on("epoqApplyGiftListCallback", (callback) => {
			console.log("get gift list called");
			if (typeof callback === "function") {
				callback(this.giftList);
			}
		});
		this.$bus.$on("epoqAddToGiftList", (item) => {
			console.log("add item", item);
			this.addToGiftList(item);
		});
		this.$bus.$on("epoqUpdateGiftList", (giftList) => {
			console.log("gift list updated", giftList);
		});
		this.$bus.$on("epoqRefreshGiftList", (data) => {
			if (this.isLoggedUser && data.sync) {
				this.giftList = this.getSyncedGiftList();
			} else {
				this.giftList = data.giftList;
			}
			console.log("gift list refreshed", this.giftList);
		});
		this.$bus.$on("epoqRemoveFromGiftList", (item) => {
			console.log("remove productId", item.productId);
			this.removeFromGiftList(item);
			if (this.$parent.$data.isWishListPage) {
				// NOTE: disabled as refresh probably handled in SPA context
				// this.refreshWishListPage();
			}
		});
		this.$bus.$on("epoqClearGiftList", async () => {
			console.log("clear gift list");
			await this.clearGiftList();
			if (this.$parent.$data.isWishListPage) {
				// NOTE: disabled as refresh probably handled in SPA context
				// this.refreshWishListPage();
			}
		});
		this.$bus.$on("epoqShowClubModal", (clubDiscount) => {
			console.log("show club modal event with clubDiscount: ", clubDiscount);
			if (clubDiscount.DiscountType === 0) {
				this.clubDiscount = Math.floor(clubDiscount.Reduction) + ".- CHF";
			} else if (clubDiscount.DiscountType === 1) {
				this.clubDiscount = Math.floor(clubDiscount.Percentage) + "%";
			}
			this.showClubModal = !!this.clubDiscount;
		});
		this.$bus.$on("epoqHideClubModal", (clubDiscount) => {
			console.log("hide club modal event");
			this.clubDiscount = "";
			this.showClubModal = false;
		});
	}

	@Watch("giftList")
	onPropertyChanged(value: string[], oldValue: string[]) {
		const giftListCnt = value.length;
		// this.giftList = value;
		this.hasGiftList = !!giftListCnt;
		// if (value !== oldValue) {
		this.saveGiftList(value);
		this.updateWishListCounter(giftListCnt.toString());
		this.$bus.$emit("epoqUpdateGiftList", this.giftList);
		// }
	}

	getGiftList() {
		return this.getSyncedGiftList();
	}

	getSyncedGiftList() {
		const localGiftList = JSON.parse(
			window.localStorage.getItem(this.$parent.$data.storageKey) || "[]",
		);
		const currentGiftList = this.$parent.$data.giftList;

		if (!this.isLoggedUser) {
			return currentGiftList;
		}

		(async () => {
			for (let i = 0; i < localGiftList.length; i++) {
				let item = localGiftList[i];
				if (!this.isGiftListItem(item, currentGiftList)) {
					const added = await this.addToGiftList(item);
				}
			}
		})();

		return currentGiftList;
	}

	isGiftListItem(item, currentGiftList) {
		const itemsInList = currentGiftList.filter((currItem) => {
			return currItem.productId === item.productId;
		});
		return itemsInList.length;
	}

	activateGiftList() {
		this.hasGiftList = true;
		console.log("activated");
	}

	disableGiftList() {
		this.hasGiftList = false;
		console.log("disabled");
	}

	async addToGiftList(item) {
		let addedToRemoteGiftList;

		if (this.isLoggedUser) {
			addedToRemoteGiftList = await this.$parent.$data.addToRemoteGiftList(
				item.productId,
			);

			if (
				!addedToRemoteGiftList.hasOwnProperty("productIdsWholeList") ||
				!addedToRemoteGiftList.productIdsWholeList ||
				addedToRemoteGiftList.productIdsWholeList.indexOf(item.productId) === -1
			) {
				console.log("not added", item.productId);
				return;
			}
		}

		const itemJson = await this.$parent.$data.getGiftListJson([item.productId]);
		const mappedItem = this.$parent.$data.mapGiftListItems(
			itemJson.ProductTiles || [],
		);

		if (
			!mappedItem.length ||
			this.isGiftListItem(mappedItem[0], this.giftList)
		) {
			return false;
		}

		this.giftList.push(mappedItem[0]);
		console.log("added", mappedItem);
		// this.saveGiftList();

		this.sendCustomWishlistAddEvent(item);

		this.$bus.$emit("epoqAddedToGiftList", mappedItem[0]);
		return true;
	}

	async removeFromGiftList(item) {
		if (this.giftList.length < 2) {
			return await this.clearGiftList();
		}
		const removedFromRemote = await this.triggerRemoteGiftListRemoval(
			item.productId,
		);
		if (
			!removedFromRemote.hasOwnProperty("productIdsWholeList") ||
			!removedFromRemote.productIdsWholeList ||
			removedFromRemote.productIdsWholeList.indexOf(item.productId) > -1
		) {
			// NOTE: remote success currently not provided, therefore checked for empty string
			console.log("error -> could not remove from remote wishlist.");
			return;
		}
		this.giftList = this.giftList.filter(
			(curr: any) => curr.productId !== item.productId,
		);
		console.log("removed");
		// this.saveGiftList();
		this.triggerForeignGiftListRemoval(item.productId);
		this.sendCustomWishlistRemoveEvent(item);
	}

	saveGiftList(giftList) {
		window.localStorage.setItem(
			this.$parent.$data.storageKey,
			JSON.stringify(giftList),
		);
		console.log("saved to storage");
	}

	async clearGiftList() {
		const remoteGiftListCleared = await this.triggerRemoteGiftListClearing();
		if (
			!remoteGiftListCleared.hasOwnProperty("status") ||
			remoteGiftListCleared.status !== "SUCCESS"
		) {
			console.log("error -> could not clear remote wishlist.");
			return;
		}
		this.$bus.$emit("epoqCloseGiftList");
		window.localStorage.removeItem(this.$parent.$data.storageKey);
		this.giftList.map((item) => {
			this.sendCustomWishlistRemoveEvent(item);
		});
		this.giftList = [];
		this.triggerForeignGiftListRemoval(undefined);
		console.log("cleared");
	}

	async triggerRemoteGiftListRemoval(productId) {
		if (!this.isLoggedUser) {
			return { productIdsWholeList: [] };
		}
		return await this.$parent.$data.removeFromRemoteGiftList(productId);
	}

	async triggerRemoteGiftListClearing() {
		if (!this.isLoggedUser) {
			return { status: "SUCCESS" };
		}
		return await this.$parent.$data.clearRemoteGiftList();
	}

	triggerForeignGiftListRemoval(productId) {
		if (
			window["EpoqGF"] &&
			typeof window["EpoqGF"].removeFromWishlist === "function"
		) {
			window["EpoqGF"].removeFromWishlist(productId || undefined);
		}
	}

	updateWishListCounter(value) {
		this.$parent.$data.setWishListCounter(value);
		setTimeout(() => {
			const giftListCnt = this.giftList.length || 0;
			this.$parent.$data.setWishListCounter(giftListCnt.toString());
		}, 1000);
	}

	refreshWishListPage() {
		this.$bus.$emit("epoqCloseGiftList");
		window.location.reload();
	}

	sendCustomWishlistEvent(item, action) {
		window.dataLayer.push({
			event: "shopEvent",
			eventCategory: "Geschenkefinder",
			eventAction:
				"Artikel in Merkliste" + (action === "remove" ? " entfernt" : ""),
			eventLabel:
				"" +
				(item.productId || "__NOT_SET__") +
				"_|_" +
				(item.title || "__NOT_SET__") +
				"",
		});
	}

	sendCustomWishlistAddEvent(item) {
		this.sendCustomWishlistEvent(item, "add");
	}

	sendCustomWishlistRemoveEvent(item) {
		this.sendCustomWishlistEvent(item, "remove");
	}
}
